import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import TickUrl from '@img/icons/tick.svg';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';
import { FilterBreakpoint } from '../Filter/Filter.styles';
const Container = styled(m.section) `
  @media ${from(FilterBreakpoint)} {
    display: none;
  }
`;
const SelectedFilters = styled.div `
  flex: 1 0 100%;
  padding-bottom: 10px;
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow: auto;
`;
const SelectedFilterBtn = styled.button `
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  background-color: ${rgba(brand.primary.base, 0.25)};
  border: none;
  border-radius: 100000px;
  padding: 6px 15px;
  white-space: nowrap;

  svg {
    width: 10px;
    margin-left: 5px;
  }
`;
const Title = styled.span `
  ${fonts.DaxPro.Medium};
  font-size: 20px;
  margin: 0 0 10px 0;
`;
const ButtonWrapper = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 12px;
  justify-content: flex-end;

  ${ButtonStyles.Button} {
    flex: 1 1 auto;
  }
`;
const Overlay = styled(m.div) `
  position: fixed;
  top: 0;
  left: 100%;
  display: grid;
  background: ${brand.white};
  grid-template-rows: auto auto 1fr;
  height: 100%;
  padding: 0 0 14px 0;
  width: 100%;
  z-index: 100;
`;
const FilterTop = styled.div `
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  margin: 15px;
  border-bottom: 2px solid ${brand.grey.grey89};
  margin-bottom: 10px;
`;
const FilterTitle = styled.span `
  display: block;
  background: none;
  border: 0;
  color: currentColor;
  ${fonts.DaxPro.Medium};
  font-size: 24px;
  line-height: 30px;
  text-align: left;
  width: 100%;
`;
const CloseBtn = styled.button `
  border: none;
  background: none;
  padding: 0;
  width: 32px;
  height: 32px;
  justify-self: end;
`;
const CloseIcon = styled(SvgClose) `
  height: 12px;
  width: 12px;
`;
const ResetButton = styled.button `
  display: inline-flex;
  align-items: center;
  background: none;
  border: 0;
  color: currentColor;
  cursor: pointer;
  ${fonts.DaxPro.Regular};
  font-size: 14px;
  line-height: 28px;
  margin: 0;
  padding: 0;
  text-decoration: underline;
  text-underline-position: under;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const BackArrow = styled.span `
  margin-right: 8px;
`;
const FilterMid = styled.div `
  padding: 15px;
  border-bottom: 1px solid var(--highlightColorSecondary);
  background-color: var(--bgColor);

  ${ButtonStyles.Button} {
    width: 100%;
    margin-bottom: 10px;
  }
`;
const ItemList = styled.div `
  display: block;
  padding: 0 15px 15px;
`;
const Item = styled(m.div) `
  color: currentColor;
  margin: 0;
  padding: 0;
  width: 100%;
  padding: 0 15px;
  background-color: ${rgba(brand.primary.base, 0.25)};
  margin-bottom: 2px;
`;
const ItemText = styled.span `
  display: block;
`;
const Arrow = styled.span `
  display: block;
  margin-left: auto;
`;
const OptionOverlay = styled(m.div) `
  display: none;
  color: var(--fgColor);
  overflow: hidden;
  width: 100%;
  padding-bottom: 15px;
`;
const OptionList = styled.div `
  display: block;
  min-height: 0;
  overflow-y: auto;
`;
const Option = styled.div `
  display: flex;
  align-items: center;
  height: 44px;
`;
const OptionInput = styled.input `
  ${srOnly}
`;
const OptionLabel = styled.label `
  display: flex;
  color: currentColor;
  cursor: pointer;
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  line-height: 30px;

  ${OptionInput}:disabled + & {
    opacity: 0.5;
  }

  &::before {
    content: '';
    display: block;
    background-color: ${brand.white};
    border: 1px solid ${brand.white};
    border-radius: 2px;
    box-sizing: border-box;
    color: ${brand.white};
    flex: 0 0 20px;
    font-size: 18px;
    height: 20px;
    line-height: 1em;
    margin-top: 5px;
    margin-right: 10px;
    padding-top: 2px;
    text-align: center;
    width: 20px;
    background-size: 75%;
    background-position: center;
    background-repeat: no-repeat;

    ${OptionInput}:checked + & {
      background-color: ${brand.primary.alt};
      background-image: url(${TickUrl});
    }
  }
`;
const SubmitWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-direction: column;
`;
const Backdrop = styled(m.div) `
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  background: hsla(var(--accentColorPrimaryString) / 0.25);
  height: 100%;
  width: 100%;
`;
const ItemTitle = styled.button `
  ${fonts.DaxPro.Medium};
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: 0;
  color: currentColor;
  ${fonts.DaxPro.Medium};
  margin: 0;
  padding: 15px 0;
  text-decoration: none;
  text-underline-position: under;
  width: 100%;
  cursor: pointer;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const ItemArrow = styled.span `
  display: block;
  margin-left: 20px;
  place-content: center;
  place-items: center;
`;
const ItemIcon = styled.span `
  display: block;
  flex: 0 0 auto;
  height: 16px;
  margin-left: auto;
  width: 16px;
  position: relative;

  &::before,
  &::after {
    display: block;
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 16px;
    height: 2px;
    background-color: currentColor;
  }

  ${Item}[aria-expanded='true'] & {
    &::after {
      transform: translateY(-50%);
    }
  }

  &::before {
    transform: translateY(-50%);
  }

  &::after {
    transform: translateY(-50%) rotate(90deg);
  }
`;
const FilterMobileStyles = {
    Arrow,
    BackArrow,
    Backdrop,
    ButtonWrapper,
    CloseBtn,
    CloseIcon,
    Container,
    FilterMid,
    FilterTitle,
    FilterTop,
    Item,
    ItemArrow,
    ItemIcon,
    ItemList,
    ItemText,
    ItemTitle,
    Option,
    OptionInput,
    OptionLabel,
    OptionList,
    OptionOverlay,
    Overlay,
    ResetButton,
    SelectedFilterBtn,
    SelectedFilters,
    SubmitWrapper,
    Title,
};
export default FilterMobileStyles;
